import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    constructor(private messageService: MessageService) {}

    displayToastSuccess(message: string, detail?: string) {
        this.messageService.add({
            key: 'seraToastKey',
            severity: 'success',
            summary: message,
            icon: 'ci-checkbox_circle ci--green',
            detail: detail
        });
    }

    displayToastWarning(message: string, detail?: string) {
        this.messageService.add({
            key: 'seraToastKey',
            severity: 'warn',
            summary: message,
            icon: 'ci-alert',
            detail: detail
        });
    }

    displayToastInfo(message: string, detail?: string) {
        this.messageService.add({
            key: 'seraToastKey',
            severity: 'info',
            summary: message,
            icon: 'ci-information',
            detail: detail
        });
    }

    displayToastError(message: string, detail?: string) {
        this.messageService.add({
            key: 'seraToastKey',
            severity: 'error',
            summary: message,
            icon: 'ci-error ci--red',
            detail: detail
        });
    }
}
